import React from "react";
import { State, StateReducer } from "./types";

const ElementContext = React.createContext<{
  state: State;
  reducer: StateReducer;
}>({
  state: {
    minDate: "",
    maxDate: "",
    resize: {
      left: {
        isResizing: false,
        offset: 0,
      },
      right: {
        isResizing: false,
        offset: 0,
      },
    },
    drag: {
      isPressing: false,
      isDragging: false,
      offset: 0,
      clickInitialPos: 0,
    },
  },
  reducer: {
    resize: () => {},
    drag: () => {},
  },
});

function useElementContext() {
  return React.useContext(ElementContext);
}

export { ElementContext, useElementContext };
